import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription, Subject} from 'rxjs';
import { AccountEstatementsService } from '../_services/estatements.services';
import { HelperServices } from '../_services/helper.services';
import { DocumentFormService } from '../_services/document.form.services';
import { exhaustMap, map } from 'rxjs/operators';
import { Document } from '../_models/document.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-list-documents-forms',
  templateUrl: './list-documents-forms.component.html',
  styleUrls: ['./list-documents-forms.component.scss']
})

export class ListDocumentsFormsComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  loadingModalConfig: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  loadingModal: boolean = false;
  filterDocumentForm: FormGroup;
  templateView: number = 1;
  activeSubmitFilterDocument: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private layout: LayoutService,
    private auth: AuthService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private modalLoading: NgbModal,
    public helperService: HelperServices,
    public documentFormService: DocumentFormService
  ) { }

  ngOnInit(): void {
    const sb1 = this.documentFormService.isLoading$.subscribe(res => this.isLoading = res);
    this.subscriptions.push(sb1);
    this.documentFormService.fetch();
    
    this.initForm();

  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  initForm() {

    this.filterDocumentForm = this.fb.group({
      inputDocumentName: [''],
    });

  }

  submitFilterDocument(modal) {
    //this.modalLoading.open(modal, this.loadingModalConfig);

    var paramsGet = Array( 
      `Formulario=${this.filterDocumentForm.controls.inputDocumentName.value ? this.filterDocumentForm.controls.inputDocumentName.value : ""}`,
    ).join('&');
    
    this.documentFormService.patchState({ paramsGet : paramsGet });
  }

  clickDocumentView(Idformulario, content) {
    this.modalLoading.open(content, this.loadingModalConfig);

    this.documentFormService.getDocument(Array(`Idformulario=${Idformulario}`).join("&")).then((response) => {
        if(response){
          this.helperService.printPreview(response[0].Documento, response[0].NameDoc, "application/pdf");
        }
        else {
            alert("No se pudo descargar el documento");
        }
      }).finally(() => {
        this.modalLoading.dismissAll();
      }).catch(() => {
        this.modalLoading.dismissAll();
      });
  }
}
